export const systemMenus = () => ({
    Id: 15,
    id: `main-menu-2-all`,
    path: '/management/system/system-informations',
    label: 'System',
    Description: 'System helps to manage the platform with various configurations in the terms of functions, status etc.',
    isEnabled: true,
    svg: (
        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M13 2a1 1 0 0 0-1 1v2.27A7.001 7.001 0 0 0 7.27 12H5a1 1 0 1 0 0 2h2.27A7.001 7.001 0 0 0 12 18.73V21a1 1 0 1 0 2 0v-2.27A7.001 7.001 0 0 0 16.73 14H19a1 1 0 1 0 0-2h-2.27A7.001 7.001 0 0 0 14 5.27V3a1 1 0 0 0-1-1zM12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" />
        </svg>

    ),

    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'System Informations',
            path: '/management/system/system-informations',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="#007BFF" strokeWidth="2" fill="none" />
                    <path d="M17.5 11h-1V8c0-.6-.4-1-1-1h-3V5c0-.6-.4-1-1-1h-3c-.6 0-1 .4-1 1v2H7c-.6 0-1 .4-1 1v3H5c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h2v3c0 .6.4 1 1 1h3v2c0 .6.4 1 1 1h3c.6 0 1-.4 1-1v-2h3c.6 0 1-.4 1-1v-3h2c.6 0 1-.4 1-1v-3c0-.6-.4-1-1-1h-2v-3c0-.6-.4-1-1-1zM12 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Logs',
            path: '/management/system/logs',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 10h-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 8v2h2V8H6zm0 4v2h2v-2H6zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm-8 4h8v2H8v-2z" fill="#007BFF" />
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Batch Logs',
            path: '/management/system/batch-logs',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 10h-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 8v2h2V8H6zm0 4v2h2v-2H6zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm-8 4h8v2H8v-2z" fill="#007BFF" />
                </svg>

            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Schedule Tasks',
            path: '/management/system/scheduled-tasks',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.71 4.29a1 1 0 0 0-1.42 0L16 6.59V5a1 1 0 0 0-2 0v1.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.42zM12 11a1 1 0 0 0-1 1v3.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0-1.42-1.42L13 15.59V12a1 1 0 0 0-1-1zm-2-1a1 1 0 0 0 1-1V5.41l1.29 1.3a1 1 0 1 0 1.42-1.42l-2-2a1 1 0 0 0-1.42 0l-2 2a1 1 0 1 0 1.42 1.42L11 5.41V9a1 1 0 0 0 1 1z" fill="#007BFF" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M3 12c0 4.97 4.03 9 9 9s9-4.03 9-9-4.03-9-9-9-9 4.03-9 9zm1 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8z" fill="#007BFF" />
                </svg>

            ),
        },
        {
            id: `coln-1-Categories`,
            label: 'Service',
            path: '/management/system/service/parsing-rules',
            isEnabled: true,
            svg: (
                <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.71 4.29a1 1 0 0 0-1.42 0L16 6.59V5a1 1 0 0 0-2 0v1.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.42zM12 11a1 1 0 0 0-1 1v3.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0-1.42-1.42L13 15.59V12a1 1 0 0 0-1-1zm-2-1a1 1 0 0 0 1-1V5.41l1.29 1.3a1 1 0 1 0 1.42-1.42l-2-2a1 1 0 0 0-1.42 0l-2 2a1 1 0 1 0 1.42 1.42L11 5.41V9a1 1 0 0 0 1 1z" fill="#007BFF" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M3 12c0 4.97 4.03 9 9 9s9-4.03 9-9-4.03-9-9-9-9 4.03-9 9zm1 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8z" fill="#007BFF" />
                </svg>

            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Parsing Rules',
                    path: '/management/system/service/parsing-rules',
                    isEnabled: true,
                    svg: (
                        <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.71 4.29a1 1 0 0 0-1.42 0L16 6.59V5a1 1 0 0 0-2 0v1.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0 0-1.42zM12 11a1 1 0 0 0-1 1v3.59l-1.29-1.3a1 1 0 0 0-1.42 1.42l2 2a1 1 0 0 0 1.42 0l2-2a1 1 0 0 0-1.42-1.42L13 15.59V12a1 1 0 0 0-1-1zm-2-1a1 1 0 0 0 1-1V5.41l1.29 1.3a1 1 0 1 0 1.42-1.42l-2-2a1 1 0 0 0-1.42 0l-2 2a1 1 0 1 0 1.42 1.42L11 5.41V9a1 1 0 0 0 1 1z" fill="#007BFF" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M3 12c0 4.97 4.03 9 9 9s9-4.03 9-9-4.03-9-9-9-9 4.03-9 9zm1 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8z" fill="#007BFF" />
                        </svg>

                    ),
                },



            ],
        },


    ],
}
)
